import { useEffect } from 'react';
import { NextRouter } from 'next/router';
import { getGlobals, setGlobals } from '../globals';
import { getEffectiveTimeRangeFromURL } from '../../../../utils';
import { GLOBALS_VARIABLES } from '../../../../constants';

const useHandleRouteChange = (router: NextRouter) => {
  useEffect(() => {
    const handleRouteChange = () => {
      const currentGlobals = getGlobals();
      const { since, until } = getEffectiveTimeRangeFromURL(currentGlobals);
      if (currentGlobals.hasOwnProperty('editMode')) {
        // retain current global variables and overwrite the time range variables from the URL in edit mode
        setGlobals(GLOBALS_VARIABLES, currentGlobals.variables);
      } else {
        // empty current global variables but overwrite the time range variables from the URL
        // for dashboards that are based on "internal routing" cases (Anzen use case)
        setGlobals(GLOBALS_VARIABLES, { since, ...(until ? { until } : {}) });
      }
    };

    router.events.on('routeChangeStart', handleRouteChange);

    return () => router.events.off('routeChangeStart', handleRouteChange);
  }, []);
};

export default useHandleRouteChange;
